/* eslint-disable security/detect-object-injection */
import React from 'react';
import { Image } from 'nordic/image';
import PropTypes from 'prop-types';
import { BackgroundImageSection } from './backgroundImageSection';

const getClass = (isSimple, suffix) => `hero${isSimple ? '-simple' : '-full'}${suffix || ''}`;

const geContents = (isSimple, backgroundImage, children) => {
  if (isSimple) {
    return (
      <div className="hero-contents__text">
        {children}
      </div>);
  }
  return (
    <>
      <div className="hero-contents__text">
        {children}
      </div>
      <div className="hero-contents__image">
        <Image
          onload="on"
          src={backgroundImage.image}
          alt="MP"
        />
      </div>
    </>);
};

const Hero = ({
  isSimple,
  children,
  backgroundImage,
}) => (
  <header
    className={getClass(isSimple)}
  >
    {backgroundImage && (
    <BackgroundImageSection
      backgroundImage={backgroundImage}
    />
    )}
    <div className={getClass(isSimple, '-content')}>
      <div className="hero-content__safe-area-top" />
      {geContents(isSimple, backgroundImage, children)}
    </div>
  </header>
);

Hero.propTypes = {
  isSimple: PropTypes.bool,
  children: PropTypes.node.isRequired,
  backgroundImage: PropTypes.shape({
    image: PropTypes.string,
    original: PropTypes.string,
  }),
};

export { Hero };
